/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualVersion: core.serialization.ObjectSchema<
    serializers.NotEqualVersion.Raw,
    Truvity.NotEqualVersion
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace NotEqualVersion {
    export interface Raw {
        value: number;
    }
}
